const error = "/_app/immutable/assets/error.9OjnU5ML.png";
export {
  error as default
};
